module.exports = __webpack_public_path__ + "static/media/insurance.4d268261.png";